import { CELSIUS, FAHRENHEIT, TEMPERATURE, TemperatureUnit } from '../units';
import { BaseConverter } from './base-converter';


/**
 * Temperature unit converter class
 */
export class TemperatureConverter extends BaseConverter<TemperatureUnit> {
  protected _baseUnit: TemperatureUnit = CELSIUS;

  constructor() {
    super(TEMPERATURE);
    this._baseConversionFunctions.set(FAHRENHEIT, (value: number) => value * 9 / 5 + 32);
    this._reverseConversionFunctions.set(FAHRENHEIT, (value: number) => (value - 32) * 5 / 9);
    this._check();
  }
}


/**
 * Temperature unit converter singleton
 */
export const TEMPERATURE_CONVERTER: TemperatureConverter = new TemperatureConverter();
